import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFeatureFlag } from "../../../helpers/featureFlags";

/** Legacy helper — Receiving now lives under Inventory. */
export function ReceivingLegacyRedirect() {
  return <Navigate to="/admin/inventory/receiving" replace />;
}

export function SellersLegacyRedirect() {
  const enabled = useFeatureFlag("inventory.3pl");
  if (!enabled) return <Navigate to="/dashboard" replace />;
  return <Navigate to="/admin/3pl/sellers" replace />;
}

export function WarehouseLegacyRedirect() {
  return <Navigate to="/settings/inventory/warehouse" replace />;
}

/** Sync settings live with the store owner (3PL for admins, Inventory for sellers). */
export function SyncSettingsLegacyRedirect() {
  const enabled = useFeatureFlag("inventory.3pl");
  const isAdmin = !!useSelector(
    (s) => s?.currentUser?.user?.isEnterpriseAdmin
  );
  if (!enabled) return <Navigate to="/dashboard" replace />;
  return (
    <Navigate
      to={isAdmin ? "/admin/3pl/sync-settings" : "/inventory/sync-settings"}
      replace
    />
  );
}

export function BlankPosLegacyRedirect() {
  return <Navigate to="/admin/inventory/purchase-orders" replace />;
}

/** Legacy Seller stock → 3PL Retail stock (RTL.1). */
export function SellerStockLegacyRedirect() {
  const enabled = useFeatureFlag("inventory.3pl");
  const { search } = useLocation();
  if (!enabled) return <Navigate to="/dashboard" replace />;
  return (
    <Navigate to={`/admin/3pl/retail-stock${search || ""}`} replace />
  );
}
